import React from "react";
import { FaEye, FaLayerGroup, FaUsers } from "react-icons/fa";

import {
  getAllCoachNames,
  getGroupAdherentsCount,
  getGroupColorClasses,
  getGroupName,
  getStatusLabel,
  getStatusStyle,
} from "../utils/adminGroupsUtils";

function GroupsMobileList({ groups = [], onOpen }) {
  return (
    <section className="space-y-3 lg:hidden">
      {groups.map((group) => {
        const color = getGroupColorClasses(group);
        const count = getGroupAdherentsCount(group);

        return (
          <article
            key={group.id}
            className="rounded-[1.75rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20"
          >
            <div className="flex items-start gap-3">
              <div
                className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br ${color.gradient} text-white`}
              >
                <FaLayerGroup />
              </div>

              <div className="min-w-0 flex-1">
                <p className="font-bold text-slate-950 dark:text-white">
                  {getGroupName(group)}
                </p>

                <p className="mt-1 text-xs font-semibold text-slate-400">
                  {getAllCoachNames(group)}
                </p>

                <div className="mt-3 flex flex-wrap gap-2">
                  <span
                    className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getStatusStyle(
                      group,
                    )}`}
                  >
                    {getStatusLabel(group)}
                  </span>

                  <span className={`inline-flex min-h-8 items-center gap-2 rounded-2xl px-3 text-xs font-bold ${color.badge}`}>
                    <FaUsers />
                    {count}
                  </span>
                </div>
              </div>
            </div>

            <button
              type="button"
              onClick={() => onOpen(group)}
              className="mt-4 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
            >
              <FaEye />
              Voir le groupe
            </button>
          </article>
        );
      })}
    </section>
  );
}

export default GroupsMobileList;